export default `<?xml version="1.0" encoding="UTF-8"?>
<svg class="icon-close" width="10px" height="9px" viewBox="0 0 10 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Close</title>
  <desc>Close modal or tooltip.</desc>
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
    <g class="icon-color" transform="translate(-403.000000, -79.000000)" stroke="#7E7E7E" stroke-width="1.5">
      <path d="M404,80 L411.583453,86.3632727 M403.886653,86.4936639 L411.470106,80.1303912"></path>
    </g>
  </g>
</svg>`;
